<template>
  <Verbrauch type="heizenergie" :startGeraetTyp="$route.query.typ"/>
</template>

<script>
import Verbrauch from '@/components/Verbrauch';

export default {
  components: {
    Verbrauch,
  },
};
</script>
